import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicDashboard = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Le<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>est le tableau de bord
              qui vous permet de piloter toute votre compétition, de A à Z.
            </p>
            <p className="help-text">
              Accédez-y facilement depuis l’onglet <strong>Admin</strong> dans la barre de navigation sur ordinateur ou via le menu dans les navigateurs mobiles.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Pour devenir<a target='_blank' className="link" href={`/topics/about/3`}>Admin,</a> vous avez plusieurs possibilités :
              </p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">Vous êtes le principal organisateur, 
                    <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>contactez-nous</a>pour nous en faire la demande.
                    Nous vous attribuerons ensuite un accès.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">L'organisateur de l'event vous a attribué des droits de co-administration de la compétition</p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Les menus principaux sont accessibles depuis la barre latérale à gauche de l'écran. Ils vous permettent de naviguer facilement entre les 
                différents éléments de votre compétition.
              </p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Dashboard :</a>
                    Il vous permet de créer votre première compétition ou de sélectionner l'une de vos compétitions si vous en gérez plusieurs simultanément.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Compétitions :</a>           
                    c'est ici que vous configurez la page de votre compétition : adresse, date, description, tags et bien d'autres détails importants.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Publications :</a>
                    c'est votre centre de commande pour gérer et publier tous les aspects de votre compétition : billetterie, WODs, planning, et bien plus encore.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Catégories :</a>
                    c'est ici que vous créez les catégories dans lesquelles vos athlètes pourront s'inscrire. Vous y configurez le nombre de places disponibles, le prix, les standards, et bien plus encore.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Participants :</a>
                    gérez tous vos athlètes inscrits : envoyez-leur des e-mails, modifiez les noms des équipes, transférez une team vers une autre catégorie, ou encore dispatch en fonction du classement.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Workouts :</a>
                    divisé en deux sections : le scoring, pour gérer les scores et le leaderboard, et la diffusion, pour partager les détails des épreuves avec les athlètes.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Planning :</a>
                    une gestion automatisée pour organiser rapidement les enchaînements des heats, répartir les floors et bien plus encore.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Scores :</a>
                    pour la saisie simple et rapide des scores, catégorie par catégorie.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Staff :</a>
                      gérez ici tous les volontaires inscrits à votre compétition et ajoutez des co-organisateurs pour faciliter la gestion de votre event.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Paiements :</a>
                      votre portail centralisé pour consulter les détails des inscriptions, les statistiques, les paiements, la gestion de votre compte, et bien plus encore.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <a target='_blank' className="link" href={`#`}>Exportations :</a>
                      Un espace dédié pour exporter toutes les données liées à votre compétition : listes des participants, planning, goodies, et bien plus encore.
                  </p>
                </li>
              </ul>
              <p className="help-text mt-40">
                <strong>À noter :</strong> Certains onglets sont accessibles uniquement sous certaines conditions. Par exemple, si aucune compétition n'a été créée, 
                vous ne pourrez pas créer de catégories. De même, sans catégorie, il ne sera pas possible de créer des WODs ou de saisir des scores, et ainsi de suite. 
                Logique, non ?
              </p>
              <p className="help-text">
                L'ordre des menus n'est donc pas laissé au hasard ; il est conçu de manière intuitive. Vous ne pourrez pas vous tromper !
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Accessible sur ordinateur via la navbar, à côté de votre photo de profil, ou dans le menu pour les navigateurs mobiles, 
                le<a target='_blank' className="link" href={`#`}>mode Test</a>vous permet d’ajouter des données de test à votre compétition.
              </p>
              <p className="help-text">
                Une fois activé, le mode Test vous permet de basculer avec des données fictives de participants. Cela vous offre l’opportunité de 
                tester vos WODs, de saisir des scores, et d’ajuster les détails pour concevoir la compétition idéale.
              </p>
              <p className="help-text"><a target='_blank' className="link" href={`#`}>Pour plus de détails</a></p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicDashboard